export default __webpack_public_path__ + "static/media/report.1871c722.svg";